<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["metrics", "labels"],
  data() {
    return {
      chartData: {
        labels: this.makeLabels(),
        datasets: this.makeDataSet()
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: value => {
                  return value + "%";
                }
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: tooltipItems => {
              return tooltipItems.yLabel + "%";
            },
            footer: tooltipItems => {
              return this.footer(tooltipItems[0]);
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    makeLabels() {
      return this.metrics.map(x => x.type);
    },
    makeDataBars(metricName) {
      return this.metrics.map(x => x[metricName]);
    },
    footer(items) {
      let label = "";
      if (items.datasetIndex === 0) {
        label = " Day total: " + this.metrics[items.index].lastBusinessDayMetric;
      } else if (items.datasetIndex === 1) {
        label = "Week total: " + this.metrics[items.index].weekToDateMetric;
      } else if (items.datasetIndex === 2) {
        label = "Month total: " + this.metrics[items.index].monthToDateMetric;
      }
      return label;
    },
    makeDataSet() {
      return [
        {
          label: "Last Business Day",
          backgroundColor: "rgb(0, 255, 251, 0.4)",
          borderColor: "rgb(0, 255, 251, 1)",
          borderWidth: 1,
          data: this.makeDataBars("lastBusinessDayPercentage")
        },
        {
          label: "Week to Date",
          backgroundColor: "rgb(255, 204, 204, 0.4)",
          borderColor: "rgb(255, 204, 204, 1)",
          borderWidth: 1,
          data: this.makeDataBars("weekToDatePercentage")
        },
        {
          label: "Month to Date",
          backgroundColor: "rgb(255, 255, 77, 0.4)",
          borderColor: "rgb(255, 255, 77, 1)",
          borderWidth: 1,
          data: this.makeDataBars("monthToDatePercentage")
        }
      ];
    }
  }
};
</script>
